import { IconUsers } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import type { UserStoriesData } from '../../directives/renderers/UserStoriesRenderer';
import { UserStoriesBlockView } from './UserStoriesBlockView';

export const userStoriesPlugin: BlockPlugin<UserStoriesData> = {
    name: 'userStories',
    displayName: 'User Stories',
    hasData: true,
    defaultData: { mvpFilter: 'all' as const },
    Component: UserStoriesBlockView,
    toolbarInsert: {
        icon: <IconUsers size={16} />,
        title: 'User Stories',
        description: 'Add user stories from Notion',
        category: 'component'
    }
};

registerBlockPlugin(userStoriesPlugin);
